import {
    createAsyncThunk,
    createSelector,
    createSlice,
    PayloadAction,
  } from '@reduxjs/toolkit';
  
export const VOICE_PREFERNCE_FEATURE_KEY = 'voicePreference';

interface VoicePreferenceRadio {
    data:  Array<{
        value: string; 
        label: string;
        toolTipText:string;
        showRadioOption:boolean;
    }>
    defaultSelected: string;
    showInfoIcon: boolean;
}
interface VoicePrefInputText {
    enteredVoicePrefInput:string;
}
interface ButtonType {
    buttonDisabled: boolean;
} 
interface VoicePrefCheckbox {
    checkboxVal: boolean;
    
}
interface VoicePrefError {
    message: string;
    status: boolean;
}
interface RedirectToDashboard {
    status: boolean;
}
interface keyable {
  [key: string]: any;
}
  
export interface VoicePreferenceState {
    radioDataOptions: VoicePreferenceRadio;
    voicePrefInput: VoicePrefInputText;
    buttonTypeOptions: ButtonType;
    checkboxTypeOptions: VoicePrefCheckbox;
    error:VoicePrefError;
    redirectToDashboard: RedirectToDashboard;
}

export const navigateToDashboard = createAsyncThunk(
    'voicePreference/navigateToDashboard',
    async (data: {voiceInputVal : string, selectedVoicePref : string} , { rejectWithValue } ) => {
        if(((data.selectedVoicePref === 'phone' || data.selectedVoicePref === 'stationId') && data.voiceInputVal.length > 1) || data.selectedVoicePref === 'softPhone'){
            return Promise.resolve({
                redirectToDashboard: {
                    status: true
                }
            });
        }
        else{
            return rejectWithValue('Something went wrong. Please Try Again!')
        }
    }
)

  
export const initialVoicePrefernceState: VoicePreferenceState = {
    radioDataOptions : {
        data : [{
            value:'phone',
            label: 'Set Phone Number',
            toolTipText: 'Phone Number',
            showRadioOption: true
        },
        {
            value: 'stationId',
            label: 'Set Station ID',
            toolTipText: 'Station ID',
            showRadioOption: true
        },
        {
            value: 'softPhone',
            label: 'Integrated Softphone',
            toolTipText: 'Integrated Softphone',
            showRadioOption: true
        },
        {
            value: 'microsoftAcs',
            label: 'Microsoft ACS',
            toolTipText: 'Microsoft ACS',
            showRadioOption: true
        }
    ],
    defaultSelected: 'phone',
    showInfoIcon: true
    },
    voicePrefInput: {
        enteredVoicePrefInput: ''
    },
    buttonTypeOptions: {
        buttonDisabled: true
    },
    checkboxTypeOptions: {
        checkboxVal: false
    },
    error: {
        message: '',
        status: false,
    },
    redirectToDashboard: {
        status: false
    }
};
  
export const voicePreference = createSlice({
    name: VOICE_PREFERNCE_FEATURE_KEY,
    initialState: initialVoicePrefernceState,
    reducers: {
        /**
         * Function to check voice preference radio selection
         * @param state - VoicePreferenceState
         * @param action - PayloadAction<string>
         * @example dispatch(checkVoicePrefRadioSelection(e.target.value));
         * @returns 
         */
        checkVoicePrefRadioSelection(state, action: PayloadAction<string>){
            return {
                ...state,
                radioDataOptions:{
                ...state.radioDataOptions,
                defaultSelected: action.payload
                },
                error : {
                ...state.error , 
                message : '' , 
                status : false
                },
                voicePrefInput : {
                ...state.voicePrefInput , 
                enteredVoicePrefInput : ''
                },
                buttonTypeOptions: {
                ...state.buttonTypeOptions,
                buttonDisabled: action.payload === 'softPhone' ? false : true
                },
            }
        },
        /**
         * Function to set voice preference input text
         * @param state - VoicePreferenceState
         * @param action - PayloadAction<string> 
         * @example dispatch(setVoicePrefInputText(e.target.value));
         * @returns 
         */
        setVoicePrefInputText(state , action: PayloadAction<string>) {
            return {
                ...state,
                voicePrefInput : {
                ...state.voicePrefInput , 
                enteredVoicePrefInput : action.payload
                },
                buttonTypeOptions: {
                ...state.buttonTypeOptions,
                buttonDisabled: action.payload.length > 0 ? false : true
                },
                error : {
                ...state.error , 
                message : '' , 
                status : false
                }
            }
        },
        /**
         * Function to set checkbox selection
         * @param state - VoicePreferenceState
         * @param action - PayloadAction<boolean>
         * @example dispatch(setCheckBoxSelection(e.target.checked));
         * @returns 
         */
        setCheckBoxSelection(state, action: PayloadAction<boolean>) {
            return {
                ...state,
                checkboxTypeOptions:{
                ...state.checkboxTypeOptions,
                checkboxVal: action.payload
                }
            }
        },
         /**
         * 
         * @param state - VoicePreferenceState
         * @param action - PayloadAction<keyable>
         * @example dispatch(resetVoicePrefSate)
         * @returns 
         */
         resetVoicePrefState() {
            return {
            radioDataOptions : {
                data : [{
                    value:'phone',
                    label: 'Set Phone Number',
                    toolTipText: 'Phone Number',
                    showRadioOption: true
                },
                {
                    value: 'stationId',
                    label: 'Set Station ID',
                    toolTipText: 'Station ID',
                    showRadioOption: true
                },
                {
                    value: 'softPhone',
                    label: 'Integrated Softphone',
                    toolTipText: 'Integrated Softphone',
                    showRadioOption: true
                }],
            defaultSelected: 'phone',
            showInfoIcon: true
            },
            voicePrefInput: {
                enteredVoicePrefInput: ''
            },
            buttonTypeOptions: {
                buttonDisabled: true
            },
            checkboxTypeOptions: {
                checkboxVal: false
            },
            error: {
                message: '',
                status: false,
            },
            redirectToDashboard: {
                status: false
            }

            };
        },
        /**
         * Function to check is web RTC enabled
         * @param state - VoicePreferenceState
         * @param action - PayloadAction<any>
         * @example  dispatch(isWebRTCEnabled(props.consumerAppName));
         */
        isWebRTCEnabled(state, action: PayloadAction<any>) {
          state.radioDataOptions.data[2].showRadioOption = action.payload;
        },
        /**
         * Function to set setredirectToDashboardOnLogout
         * @param state - setredirectToDashboardOnLogout
         * @param action - 
         * @example  dispatch(setredirectToDashboardOnLogout);
         */
        setredirectToDashboardOnLogout(state) {
            return {
                ...state,
                redirectToDashboard : {
                    status: false,
                }
            }
          },
        /**
         * 
         * @param state - VoicePreferenceState
         * @param action - PayloadAction<keyable>
         * @example dispatch(setAgentSession`{}`)
         * @returns 
         */
        setAgentSession(state, action: PayloadAction<keyable>) {
          return {
            ...state,
            actionObj: action.payload,
          };
    },
    },
    extraReducers: (builder) => {
        builder
        .addCase( navigateToDashboard.fulfilled , (state) => {
            return {
                ...state,
                redirectToDashboard : {
                    status: true
                }
            }
        })
       
    }
});
  
  export const voicePreferenceReducer = voicePreference.reducer;
  export const voicePreferenceActions = voicePreference.actions;
  
/**
 * Function to get voice preference state
 * @param rootState - VoicePreferenceState
 * @returns It returns voice preference
 * @example - const voicePreference = getVoicePreferenceState(rootState)
 */
  const getVoicePreferenceState = (rootState: { voicePreference : VoicePreferenceState }) => {
    return rootState[VOICE_PREFERNCE_FEATURE_KEY];
  }
  
  export const selectVoicePrefernceState = createSelector(getVoicePreferenceState, state =>state.radioDataOptions)
  export const selectVoicePrefInputState = createSelector(getVoicePreferenceState, state => state.voicePrefInput)
  export const selectVoicePrefernceBtnState = createSelector(getVoicePreferenceState, state =>state.buttonTypeOptions)
  export const selectVoicePrefCheckboxState = createSelector(getVoicePreferenceState, state =>state.checkboxTypeOptions)
  export const selectVoicePrefErrorState =createSelector(getVoicePreferenceState, state => state.error )
  export const selectVoicePrefRedirectState = createSelector(getVoicePreferenceState, state=>state.redirectToDashboard);